module.exports = __webpack_public_path__ + "static/media/onama-2 1.ba801574.png";